import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const BlogLayout = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col lg:flex-row gap-6 px-6 lg:px-16 py-8 bg-gray-50">
        {/* Blog Post Section */}
        <div className="lg:w-2/3">
          <article className="bg-white shadow-md rounded-lg p-6">
            <h1 className="text-2xl font-bold text-gray-800">
              Efficient Energy Solutions: A Case Study of a 6.2kW Solar
              Installation in Lagos
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              April 22, 2024 by Odedeyi Damilare
            </p>
            <br />
            <p className="font-semibold text-lg">Introduction</p>
            <p className="text-gray-700 mt-4">
              As energy prices rise and the demand for reliable electricity
              grows, solar power has become a practical solution for homes and
              businesses in Nigeria. In this post, we highlight a recent
              installation by Solaris Surge Energy Solutions Ltd for a hotel in
              Lagos, showcasing how solar energy can revolutionize power supply,
              reduce costs, and support sustainability.
            </p>
            <img
              src="/Assets/solarblog.jpg"
              alt="Farm"
              className="w-full h-auto mt-4 rounded-md"
            />
            <p className="">Installation</p>
            <br />
            <p className="font-semibold text-lg">System Overview</p>
            <p>
              This installation is a powerful and reliable hybrid solar energy
              system tailored to meet the hotel’s specific energy needs. Here’s
              what makes it exceptional:
            </p>
            <br />
            <p className="font-semibold">1. Hybrid Inverter:</p>
            <p className="">
              A 6.2kW SAKO Hybrid Inverter with High Voltage MPPT, rated for
              6,000W PV input and capable of 100A charging. This ensures
              efficient solar energy conversion and battery charging.
            </p>
            <br />
            <p className="font-semibold">2. Energy Storage:</p>
            <p className="">
              The system includes a 15kWh LiFePO4 (LFP) battery, offering
              durable and efficient energy storage with a long lifespan.
            </p>
            <br />
            <p className="font-semibold">3. Solar Panels:</p>
            <p>
              A rooftop array of 24 solar panels, each rated at 350W, delivering
              a combined output of 8.4kW during peak sunlight hours.
            </p>
            <br />
            <p className="font-semibold">What This System Powers</p>
            <p>
              Designed to handle the hotel’s light loads, this system powers:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li> Ceiling and standing fans in guest rooms.</li>
              <li> Light points across the facility.</li>
              <li>
                {" "}
                Other essential electronics, excluding heavy loads like air
                conditioners (ACs).
              </li>
            </ul>{" "}
            <br />
            <p>
              The system ensures uninterrupted electricity for critical hotel
              operations, enhancing the guest experience and reducing reliance
              on grid power or diesel generators.
            </p>
            <br />
            <p>
              Cost Savings Over 15 Years Let’s break down the financial
              benefits:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Band A Tariff in Lagos: ₦207 per kWh.</li>
              <li>
                Daily Energy Production: With 24 panels and optimal sunlight,
                the system generates approximately 30–40kWh daily. Assuming
                30kWh for a conservative estimate:
              </li>
              <li>Monthly production: 900kWh (30kWh/day × 30 days).</li>
              <li>Annual production: 10,800kWh (900kWh × 12 months).</li>
              <li>Savings on Electricity Bills:</li>
              <li>
                Annual cost of grid power for 10,800kWh: ₦2,235,600 (₦207 ×
                10,800kWh).
              </li>
              <li>Over 15 years: ₦33,534,000 in savings!</li>
            </ul>
            <br />
            <p>
              These savings exclude additional benefits like avoided generator
              costs, fuel expenses, and maintenance, making the system even more
              cost-effective.
            </p>
            <br />
            <p className="font-semibold">Environmental Impact</p>
            <p>
              Beyond financial savings, the system significantly reduces the
              hotel’s carbon footprint:
            </p>
            <p>
              Over 15 years, this solar installation prevents the emission of
              tons of CO₂, equivalent to planting hundreds of trees or avoiding
              thousands of liters of diesel use.
            </p>
            <br />
            <p className="font-semibold">
              Why Choose Solaris Surge Energy Solutions?
            </p>
            <p>
              This installation highlights Solaris Surge Energy Solutions’
              commitment to delivering:
            </p>
            <p>Custom-tailored solar solutions for specific energy needs.</p>
            <p>
              High-performance components like SAKO inverters and LFP batteries.
            </p>
            <p>
              Expertise in handling installations for businesses, homes, and
              institutions.
            </p>
            <br />
            <p className="font-semibold">Conclusion</p>
            <p>
              With rising energy tariffs and grid instability, switching to
              solar energy is not only sustainable but also highly economical.
              This 6.2kW system demonstrates how renewable energy can power
              essential operations while saving millions over its lifetime
            </p>
            <br />
            <p>
              Are you ready to make the switch? Contact{" "}
              <Link
                className=" text-green-500 hover:underline"
                to="/contactsection"
              >
                Solaris Surge Energy Solutions
              </Link>{" "}
              today and take the first step toward energy independence.
            </p>
          </article>
        </div>

        {/* About Me Sidebar */}
        <div className="w-full lg:w-1/3 lg:pl-8">
          <div className="bg-white shadow-lg rounded-xl p-6 flex flex-col items-center lg:items-start text-center lg:text-left">
            {/* Title */}
            <h2 className="text-2xl font-bold mb-4 text-green-700">About Me</h2>

            {/* Image */}
            <img
              src="/Assets/Odedeyi.jpeg" // Replace with actual image path
              alt="About Me"
              className="w-40 h-40 rounded-lg object-cover mb-4 shadow-md"
            />

            {/* Text */}
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Welcome to <span className="font-semibold">Solarissurge.net</span>
              ! I’m the founder of this platform and a solar energy expert with
              years of hands-on experience in{" "}
              <span className="font-medium">
                solar panel installations, battery solutions, and renewable
                energy systems
              </span>
              . Over the years, I’ve helped countless homes and businesses
              across the country switch to clean, reliable solar power. At
              Solarissurge, our mission is simple: to make solar energy
              <span className="text-green-700 font-semibold">
                {" "}
                affordable, accessible, and sustainable
              </span>
              for everyone. Whether you’re looking to install solar panels,
              purchase high-quality batteries, or explore complete energy
              solutions, you’re in the right place. I’m passionate about driving
              the adoption of solar power and empowering individuals and
              businesses to take control of their energy needs.
            </p>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default BlogLayout;
